import {useContext} from 'react';

import ContactContext from '../../contexts/ContactContext';

const useContact = () => {
  return useContext(ContactContext);
};

export default useContact;
